module.exports = {
    id: 50,
    name: "联通年年焕新理赔",
    type: "claimSettlement",
    idFlag: true,
    form: [
        {
            label: "姓名",
            prop: "name",
            obj: "order",
            type: "input"
        },
        {
            label: "手机号",
            prop: "phone",
            obj: "order",
            type: "input"
        },
        {
            label: "身份证号",
            prop: "id_card",
            obj: "order",
            type: "input"
        },
        {
            label: "IMEI",
            prop: "imei",
            obj: "order",
            type: "input"
        },
        {
            label: "手机品牌",
            prop: "brand_id",
            obj: "order",
            type: "select",
            optListName: "brandList",
            optLabel: "brand",
            optValue: "brand_id",
            relate: "model"
        },
        {
            label: "手机型号",
            prop: "model_id",
            obj: "order",
            type: "select",
            optListName: "modelList",
            optLabel: "model_name",
            optValue: "model_id"
        },
        {
            label: "手机规格",
            prop: "ram_size",
            obj: "order",
            type: "select",
            optListName: "RAMList"
        },

        {
            label: "产品名称",
            prop: "insure_san",
            obj: "order",
            type: "insure_san"
        },
        {
            label: "购买子险种营业厅",
            prop: "shop_name",
            obj: "order",
            type: "input"
        },
        {
            label: "抵扣金额",
            prop: "claims_money",
            obj: "order",
            type: "claims_money"
        },
        // {
        //     label: "手机故障",
        //     prop: "damage_title",
        //     obj: "order",
        //     type: "input"
        // },
        {
            label: "审核结果",
            prop: "exa_status",
            obj: "order",
            type: "radio",
            optListName: "statusList",
            optLabel: "name",
            optValue: "status"
        },
        {
            label: "回复内容",
            prop: "fail_exp",
            obj: "order",
            type: "textarea"
        },
        {
            label: "申请照片",
            prop: "claims_imgs",
            obj: "order",
            type: "claims_imgs"
        },
    ],
    tableColumns: [
        {
            slotName: "headimg"
        },
        {
            label: "注册者昵称",
            prop: "nickname"
        },
        {
            slotName: "operation"
        }
    ],
    piccCallbackType: 2
}

